import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [welcomeBonus, setWelcomeBonus] = useState(0);

  useEffect(() => {
    if (!getToken()) { setReady(true); return; }
    api.me()
      .then((r) => { setUser(r.data); if (r.data?.welcome_bonus) setWelcomeBonus(r.data.welcome_bonus); })
      .catch(() => setToken(""))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.login(email, password);
    setToken(data.token); setUser(data.user); return data.user;
  };
  const register = async (email, password, username, age) => {
    const ref = (typeof localStorage !== "undefined" && localStorage.getItem("nicabros_ref")) || undefined;
    const abVariant = (typeof localStorage !== "undefined" && localStorage.getItem("nicabros_ab_signup")) || undefined;
    const { data } = await api.register(email, password, username, age, ref, abVariant);
    setToken(data.token); setUser(data.user);
    if (data.welcome_bonus) setWelcomeBonus(data.welcome_bonus);
    try { localStorage.removeItem("nicabros_ref"); } catch {}
    return data.user;
  };
  const refreshUser = async () => {
    try {
      const r = await api.me();
      setUser(r.data);
      if (r.data?.welcome_bonus) setWelcomeBonus(r.data.welcome_bonus);
      return r.data;
    } catch { return null; }
  };
  const clearWelcomeBonus = () => setWelcomeBonus(0);
  const logout = () => { setToken(""); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refreshUser, welcomeBonus, clearWelcomeBonus, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
